import $ from 'jquery';

$(function(){
	
	var $instafeed = $('div.instafeed');
	if($instafeed.length == 1) {
		
		var picBatchSize = 16;
		
		function addInstaImages(){
		
			var startNum = $instafeed.find('a').length;
		
			$.getJSON(themePath()+'/lib/getInstaFeed.php?start='+startNum+'&batch='+picBatchSize, function(data) {
				$.each(data.feed, function(i, item) {
					var imgSrc = themePath()+'/lib/getInstaImage.php?url='+encodeURIComponent(item.src);
					var a = document.createElement('a');
					a.setAttribute('href', item.link);
					a.setAttribute('title', item.caption);
					a.style.backgroundImage = 'url(\''+imgSrc+'\')';
					$instafeed[0].appendChild(a);
					var newImg = new Image;
					newImg.onload = function() {
						a.classList.add('show');
					}
					newImg.src = imgSrc;
				});
				
				if(!data.more) $('.insta .more').addClass('hide');
				
			});
			
		}
		
		addInstaImages();
		
		$('.insta .more a').click(function(e){
			e.preventDefault();
			addInstaImages();
		});
			
	}
		
});